import ICDiscord from "@/components/Icon/ICFooter/ICDiscord";
import ICTele from "@/components/Icon/ICFooter/ICTelegram";
import ICX from "@/components/Icon/ICFooter/ICX";
import { ICLogo } from "@/components/Icon/ICLogo";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import config from "@/config";

export default function DesktopFooter() {
  const { t } = useTranslation();
  return (
    <footer className="w-full text-white py-4 px-6 grid grid-cols-12 items-center justify-center h-[100px] bg-blend-soft-light">
      {/* Left section - 3 columns */}
      <div className="col-start-2 col-span-3 flex items-center">
        <Link to="/" className="flex items-center">
          <ICLogo width="40" height="40" className="mx-2" />
          <span className="text-xl font-bold">MoneyFi</span>
        </Link>
      </div>

      {/* Middle section - 6 columns */}
      <div className="col-span-4 text-sm text-gray-400 flex justify-center items-center gap-2">
        <span>© 2025 moneyfi.fund</span>
        <span className="mx-1">/</span>
        <Link to="/" className="hover:text-white transition-colors">
          {t("footer.terms")}
        </Link>
        <span className="mx-1">/</span>
        <Link to="/" className="hover:text-white transition-colors">
          {t("footer.privacy")}
        </Link>
      </div>

      {/* Right section - 3 columns */}
      <div className="col-span-3 flex items-center gap-3 justify-end mr-[10%]">
        <a href={config.SOCIAL.FACEBOOK} className="flex items-center">
          <FacebookRoundedIcon
            sx={{ color: "var(--gray-5)", fontSize: "28px" }}
          />
        </a>
        <a href={config.SOCIAL.TELEGRAM} className="flex items-center">
          <ICTele width="24" height="24" />
        </a>
        <a href={config.SOCIAL.DISCORD} className="flex items-center">
          <ICDiscord width="24" height="24" />
        </a>
        <a href={config.SOCIAL.TWITTER} className="flex items-center">
          <ICX width="24" height="24" />
        </a>
      </div>
    </footer>
  );
}
